import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { ActivatedRoute } from '@angular/router';
import { PermissionConfig } from 'src/app/core/constants/permission-config';
import { ContractService } from 'src/app/core/services/contract.service';
import {ServeyService} from '../../../../../core/services/survey.service';

@Component({
  selector: 'app-analysis-report',
  templateUrl: './analysis-report.component.html',
  styleUrls: ['./analysis-report.component.scss']
})
export class AnalysisReportComponent implements OnInit {

  //declare value set
  currentUserType: string;
  enterpriseId: string;

  // uer type
  userSysAdminType = PermissionConfig.USER_SYS_ADMIN_TYPE; // 0 - admin he thong ADMIN
  userEnterpriseAdminType = PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE; // 1 - admin doanh nghiep
  userEnterpriseStaffType = PermissionConfig.USER_ENTERPRISE_STAFF_TYPE; // 2 - nhan vien cua doanh nghiep
  userEnterpriseCustomerType = PermissionConfig.USER_ENTERPRISE_CUSTOMER_TYPE; // 3 - khach hang cua doanh nghiep
  userEnterpriseDocument = PermissionConfig.USER_ENTERPRISE_DOCUMENT; // 5  - Khach hang cua doanh nghiep
  userPersonalAdminType = PermissionConfig.USER_ENTERPRISE_DOCUMENT; // 5
  userWaitingDocument = PermissionConfig.USER_WAITING_DOCUMENT; // 6
  userCustomerEnterprise = PermissionConfig.USER_CUSTOMER_ENTERPRISE // 4

  constructor(
    private contractService: ContractService,
    private serviceSurvey: ServeyService) {

  }

  ngOnInit() {
    this.currentUserType = localStorage.getItem('userType');
    this.serviceSurvey.loadSurvey();
  }




}
